module.exports = __webpack_public_path__ + "img/relief_4.38bb9d26.jpg";